// assets/js/controllers/registers_report_controller.ts

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    static values = {
        downloadBase:    String,
        standardColumns: { type: Array, default: [] },
    }

    declare downloadBaseValue:    string
    declare standardColumnsValue: string[]

    /* ==============================
     * DOWNLOAD
     * Reads filters from the index page (not from this controller)
     * ============================== */

    download(event: Event): void {

        const btn    = event.currentTarget as HTMLElement
        const format = btn.dataset.format ?? 'excel'

        const url = new URL(
            this.downloadBaseValue.replace('__FORMAT__', format),
            window.location.origin
        )

        // Tags — read from the datatable filter on the index page
        const tagsEl = document.querySelector<HTMLSelectElement>(
            '[data-dt-filter="tags"]'
        )

        if (tagsEl) {
            const ts = (tagsEl as any).tomselect
            if (ts) {
                ;(ts.items as string[]).forEach((id: string) => {
                    url.searchParams.append('tags[]', id)
                })
            } else {
                Array.from(tagsEl.selectedOptions).forEach(o => {
                    url.searchParams.append('tags[]', o.value)
                })
            }
        }

        // Tag mode (AND/OR) — read from the checked radio
        const tagModeEl = document.querySelector<HTMLInputElement>('[data-dt-filter="tag_mode"]:checked')
        url.searchParams.set('tag_mode', tagModeEl?.value ?? 'and')

        // Active / inactive — read from the datatable filter checkboxes
        const activeEl   = document.querySelector<HTMLInputElement>('[data-dt-filter="active"]')
        const inactiveEl = document.querySelector<HTMLInputElement>('[data-dt-filter="inactive"]')

        url.searchParams.set('active',   String(activeEl?.checked   ?? true))
        url.searchParams.set('inactive', String(inactiveEl?.checked ?? false))

        // Columns — scoped to this offcanvas element
        this.element.querySelectorAll<HTMLInputElement>('.report-column:checked').forEach(cb => {
            url.searchParams.append('columns[]', cb.value)
        })

        // Title — read from the input inside this offcanvas
        const titleEl = this.element.querySelector<HTMLInputElement>('#reportTitle')
        if (titleEl && titleEl.value.trim()) {
            url.searchParams.set('title', titleEl.value.trim())
        }

        window.location.href = url.toString()
    }

    /* ==============================
     * PRESET — restore standard columns
     * ============================== */

    preset(): void {

        this.element.querySelectorAll<HTMLInputElement>('.report-column').forEach(cb => {
            cb.checked = this.standardColumnsValue.includes(cb.value)
        })
    }
}
